export default __webpack_public_path__ + "static/about-ekko-bg-laptop-42a6316ad513c514163409c475097c99.jpg";